import script from "./HmisClassifierQuestions.vue?vue&type=script&lang=ts&setup=true"
export * from "./HmisClassifierQuestions.vue?vue&type=script&lang=ts&setup=true"

import "./HmisClassifierQuestions.vue?vue&type=style&index=0&id=1ffcc33e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ffcc33e"]])

export default __exports__